/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import moment from 'moment';
import {
  SET_QB_ACCESS_GQL,
  GET_QB_REFRESHTOKEN_GQL,
  GET_QB_GETQUICKBOOKENTRY_GQL,
  GET_QB_CATEGORYLIST_GQL,
  SET_SYNC_QUICKBOOK_CATEGORIES_GQL,
  GET_QB_CREDITCARDACCOUNTLIST_GQL,
  SET_CREATE_QB_ACCOUNT_GQL,
  GET_QB_CREDENTIALS_GQL,
  GET_QB_CON_ERRS_GQL,
  GET_REC_SEL_QB_CRE_CARD_ACC_GQL,
  SET_QB_POST_TRANSACTIONS_GQL,
  SET_QB_UPDATE_TRANSACTIONS_GQL,
  SET_QB_POST_JOURNAL_ENTRY_GQL,
  GET_QB_BANKACCOUNTLIST_GQL,
  SET_CREATE_QB_BANKACCOUNT_GQL,
  SET_QB_POST_BANK_TRANSACTIONS_GQL,
  SET_UPDATE_MAPPED_CREDITCARD_GQL,
  SET_SYNC_QUICKBOOK_CLASSES_GQL,
  SET_SYNC_QUICKBOOK_DIVISIONS_GQL,
  GET_QUICKBOOK_HISTORY_GQL,
  GET_QUICKBOOK_DEPARTMENT_LIST_GQL,
  GET_QUICKBOOK_CLASS_LIST_GQL,
  GET_QUICKBOOK_CHART_OF_ACCOUNTS_GQL,
  SET_SYNC_QUICKBOOK_INTERCOMPANY_TRANSACTION_GQL
} from '@/graphql/quickbook.gql';


export default {
  namespaced: true,

  state: {
    // = data
    quickBookAccessToken: null,
    quickBookRefreshToken: null,
    qbQuickbookEntry: [],
    quickBookCategoryList: [],
    quickBookCcAccountList: null,
    createdAccount: null,
    syncedQuickBookCategories: null,
    quickBookCredentials: null,
    recentlySelectedCreditCardAccount: null,
    quickBookConnectionError: null,
    syncedQuickBookTransactions: null,
    syncedQuickBookIntercompanyTransactions: null,
    quickBookBankAccountList: null,
    createdBankAccount: null,
    syncedQuickBookBankTransactions: null,
    syncedQuickBookJournalEntries: null,
    mappedCreditCardForQuickBooks: null,
    syncedQuickBookClasses: null,
    syncedQuickBookDivisions: null,
    quickBookHistory: null,
    quickBookDepartmentList:  null,
    quickBookClassesList: null,
    quickBookChartOfAccounts: null,
  },

  mutations: {
    SET_QB_ACCESS_TOKEN(state, payload) {
      state.quickBookAccessToken = payload;
    },
    GET_QB_ACCESS_REFRESH_TOKEN(state, payload) {
      state.quickBookRefreshToken = payload;
    },
    GET_QB_QUICKBOOKENTRY(state, payload) {
      state.qbQuickbookEntry = payload;
    },
    GET_QB_CATEGORYLIST(state, payload) {
      state.quickBookCategoryList = payload;
    },
    GET_QB_CREDITCARDACCOUNTLIST(state, payload) {
      state.quickBookCcAccountList = payload;
    },
    SET_CREATE_QB_ACCOUNT(state, payload) {
      state.createdAccount = payload;
    },
    GET_CLEARED_TRANSACTIONS(state, payload) {
      state.clearedTransactions = payload;
    },
    SET_SYNC_QUICKBOOK_CATEGORIES(state, payload) {
      state.syncedQuickBookCategories = payload;
    },
    SET_SYNC_QUICKBOOK_CLASSES(state, payload) {
      state.syncedQuickBookClasses = payload;
    },
    SET_SYNC_QUICKBOOK_DIVISIONS(state, payload) {
      state.syncedQuickBookDivisions = payload;
    },
    GET_QB_CREDENTIALS(state, payload) {
      state.quickBookCredentials = payload;
    },
    GET_REC_SEL_QB_CRE_CARD_ACC(state, payload) {
      state.recentlySelectedCreditCardAccount = payload;
    },
    GET_QB_CON_ERRS(state, payload) {
      state.quickBookConnectionError = payload;
    },
    SET_SYNC_QB_TRAN(state, payload) {
      state.syncedQuickBookTransactions = payload;
    },
    SET_SYNC_QUICKBOOK_INTERCOMPANY_TRANSACTION(state, payload) {
      state.syncedQuickBookIntercompanyTransactions = payload;
    },
    SET_SYNC_QB_JE(state, payload) {
      state.syncedQuickBookJournalEntries = payload;
    },
    GET_QB_BANKACCOUNTLIST(state, payload) {
      state.quickBookBankAccountList = payload;
    },
    SET_CREATE_QB_BANKACCOUNT(state, payload) {
      state.createdBankAccount = payload;
    },
    SET_SYNC_QB_BANK_TRAN(state, payload) {
      state.syncedQuickBookBankTransactions = payload;
    },
    SET_UPDATE_MAPPED_CREDITCARD(state, payload) {
      state.mappedCreditCardForQuickBooks = payload;
    },
    GET_QUICKBOOK_HISTORY(state, payload) {
      state.quickBookHistory = payload;
    },
    GET_QUICKBOOK_DEPARTMENT_LIST(state, payload) {
      state.quickBookDepartmentList = payload;
    },
    GET_QUICKBOOK_CLASS_LIST(state, payload) {
      state.quickBookClassesList = payload;
    },
    GET_QUICKBOOK_CHART_OF_ACCOUNTS(state, payload) {
      state.quickBookChartOfAccounts = payload;
    }
  },

  actions: {
    insertAccessToken({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_QB_ACCESS_GQL,
          variables: {
            authCode: payload.authCode,
            realmId: payload.realmId,
            state: payload.state,
            userId: payload.userId,
            companyId: payload.companyId,
            recordStatus: 1,
          },
        })
        .then(({ data }) => {
          commit('SET_QB_ACCESS_TOKEN', data.storeQuickBookToken);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getRefreshToken({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_QB_REFRESHTOKEN_GQL,
          variables: {
            id: payload.id,
            code: payload.code,
            userId: payload.userId,
            companyId: payload.companyId,
            returnURL: payload.returnURL,
            realmId: payload.realmId,
          },
        })
        .then(({ data }) => {
          commit('GET_QB_ACCESS_REFRESH_TOKEN', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getQuickbookEntry({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_QB_GETQUICKBOOKENTRY_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_QB_QUICKBOOKENTRY', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getQuickBookCategoryList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_QB_CATEGORYLIST_GQL,
          variables: {
            accessToken: payload.accessToken,
            realmId: payload.realmId,
            refreshToken: payload.refreshToken,
            id: payload.id,
            returnURL: payload.returnURL,
          },
          fetchPolicy: 'no-cache',
          addTypename: false,
        })
        .then(({ data }) => {
          commit('GET_QB_CATEGORYLIST', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getQuickBookCreditCardAccountList({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: GET_QB_CREDITCARDACCOUNTLIST_GQL,
          variables: {
            accessToken: payload.accessToken,
            realmId: payload.realmId,
            id: payload.id,
            refreshToken: payload.refreshToken,
            returnURL: payload.returnURL,
          },
          fetchPolicy: 'no-cache',
          addTypename: false,
        })
        .then(({ data }) => {
          commit('GET_QB_CREDITCARDACCOUNTLIST', data);
        })
        .catch(getQuickBookCreditCardAccountListErr => {
          commit('GET_QB_CREDITCARDACCOUNTLIST', { status: 'failure', error: getQuickBookCreditCardAccountListErr.message });
        });
    },
    async syncQuickBookCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_SYNC_QUICKBOOK_CATEGORIES_GQL,
          variables: {
            companyId: payload.companyId,
          },
        })
        .then((syncQuickBookCategoriesData) => {
          commit('SET_SYNC_QUICKBOOK_CATEGORIES', syncQuickBookCategoriesData.data.syncQuickBookCategories);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(syncQuickBookCategoriesErr => {          
          commit('SET_SYNC_QUICKBOOK_CATEGORIES',{status: "failure", error: syncQuickBookCategoriesErr.message});
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async createQuickBookCreditCardAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_CREATE_QB_ACCOUNT_GQL,
          variables: {
            accountId: parseInt(payload.selectedAccountId, 10),
            accountName: payload.selectedAccountName,
            activeTabName: payload.activeTabName,
            companyId: payload.companyId,
            userId: payload.userId,
            qbId: payload.quickBookTblId,
            customCreditCardAccount: payload.customCreditCardAccount,
            accessToken: payload.accessToken,
            realmId: payload.realmId,
            isCreditCardaccountChanged: payload.isCreditCardaccountChanged
          },
        })
        .then(({ data }) => {
          console.log(data);
          commit('SET_CREATE_QB_ACCOUNT', data.createQuickBookCreditCardAccount.accountId);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    async getQuickBookCredentials({ commit }) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_QB_CREDENTIALS_GQL,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_QB_CREDENTIALS', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getRecentlySelectedCreditCardAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_REC_SEL_QB_CRE_CARD_ACC_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_REC_SEL_QB_CRE_CARD_ACC', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },


    async getQuickBookConnectionError({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_QB_CON_ERRS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_QB_CON_ERRS', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async syncQuickBookTransaction({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: SET_QB_POST_TRANSACTIONS_GQL,
          variables: payload,
          context:{
            headers: {"operationname": "postQuickBookTransactions"}
          },
        })
        .then(() => {          
          apolloClient
            .mutate({
              mutation: SET_QB_UPDATE_TRANSACTIONS_GQL,
              variables: payload,
              context:{
                headers: {"operationname": "updateQuickBookTransactions"}
              },
            })
            .then(() => {
              commit('SET_SYNC_QB_TRAN', {status: "success"});
            })
            .catch(syncQuickBookUpdateTransactionErr => {              
              commit('SET_SYNC_QB_TRAN', {status: "failure", error: syncQuickBookUpdateTransactionErr.message});
            });
        })
        .catch(syncQuickBookPostTransactionErr => {          
          commit('SET_SYNC_QB_TRAN', {status: "failure", error: syncQuickBookPostTransactionErr.message});
        });
    },
    async syncQuickBookInterCompanyTransactions({ commit}, payload) {
      apolloClient
        .mutate({
          mutation: SET_SYNC_QUICKBOOK_INTERCOMPANY_TRANSACTION_GQL,
          variables: payload,
          context:{
            headers: {"operationname": "syncQuickBookInterCompanyTransactions"}
          },
        })
        .then(() => {
          commit('SET_SYNC_QUICKBOOK_INTERCOMPANY_TRANSACTION', {status: "success"});
        })
        .catch(syncQuickBookInterCompanyTransactionsErr => {          
          commit('SET_SYNC_QUICKBOOK_INTERCOMPANY_TRANSACTION', {status: "failure", error: syncQuickBookInterCompanyTransactionsErr.message});
        });
    },
    async syncQuickBookJournalEntry({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_QB_POST_JOURNAL_ENTRY_GQL,
          variables: payload,
        })
        .then((postJE) => {
          console.log('JE response after sync',postJE.data);
          const syncJERes = {
            postSuccTran: postJE.data.postQuickBookJournalEntries.successfulTransactions,
            postFailedTran: postJE.data.postQuickBookJournalEntries.failedTransactions,
          //  updateSuccTran: updateJE.data.updateQuickBookJournalEntries.successfulTransactions,
          //  updateFailedTran: updateJE.data.updateQuickBookJournalEntries.failedTransactions,
          };
          commit('SET_SYNC_QB_JE', syncJERes);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log('Error in sync',err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getQuickBookBankAccountList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_QB_BANKACCOUNTLIST_GQL,
          variables: {
            accessToken: payload.accessToken,
            realmId: payload.realmId,
            id: payload.id,
            refreshToken: payload.refreshToken,
            returnURL: payload.returnURL,
          },
          fetchPolicy: 'no-cache',
          addTypename: false,
        })
        .then(({ data }) => {
          commit('GET_QB_BANKACCOUNTLIST', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async createQuickBookBankAccount({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_CREATE_QB_BANKACCOUNT_GQL,
          variables: {
            accountId: parseInt(payload.selectedAccountId, 10),
            accountName: payload.selectedAccountName,
            companyId: payload.companyId,
            userId: payload.userId,
            qbId: payload.quickBookTblId,
            isSyncTransaction: payload.isSyncTransaction
          },
        }).then(({ data }) => {
          commit('SET_CREATE_QB_BANKACCOUNT', {uniqueId: moment.now(),accountId: data.createQuickBookBankAccount.accountId});
        })
        .catch(err => {
          console.log(err);
        });
    },
    async syncQuickBookBankTransaction({ commit }, payload) {
      apolloClient
        .mutate({
          mutation: SET_QB_POST_BANK_TRANSACTIONS_GQL,
          variables: payload,
          context:{
            headers: {"operationname": "postQuickBookBankTransactions"}
          },
        })
        .then(() => {
          commit('SET_SYNC_QB_BANK_TRAN', {status: "success"});
        })
        .catch(syncQuickBookBankTransactionErr => {
          commit('SET_SYNC_QB_BANK_TRAN', {failure: "success", error: syncQuickBookBankTransactionErr.message});
        });
    },
    async updateMappedCreditCardForQuickBooks({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_UPDATE_MAPPED_CREDITCARD_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((updateMappedCreditCardForQuickBooksData) => {
          commit('SET_UPDATE_MAPPED_CREDITCARD', updateMappedCreditCardForQuickBooksData.data.updateMappedCreditCardForQuickBooks);          
        })
        .catch(updateMappedCreditCardForQuickBooksErr => {
          commit('SET_UPDATE_MAPPED_CREDITCARD', {status: 'failure', error: updateMappedCreditCardForQuickBooksErr.message});          
        }); 
    },
    async syncQuickBookClasses( { commit}, payload) {
      await apolloClient
        .mutate({
          mutation: SET_SYNC_QUICKBOOK_CLASSES_GQL,
          variables: payload,
        })
        .then((syncQuickBookClassesData) => {
          commit('SET_SYNC_QUICKBOOK_CLASSES', syncQuickBookClassesData.data.syncQuickBookClasses);
        })
        .catch(syncQuickBookClassesErr => {          
          commit('SET_SYNC_QUICKBOOK_CLASSES',{status: "failure", error: syncQuickBookClassesErr.message});          
        });
    },
    async syncQuickBookDivisions( { commit}, payload) {
      await apolloClient
        .mutate({
          mutation: SET_SYNC_QUICKBOOK_DIVISIONS_GQL,
          variables: payload,
        })
        .then((syncQuickBookDivisionsData) => {
          commit('SET_SYNC_QUICKBOOK_DIVISIONS', syncQuickBookDivisionsData.data.syncQuickBookDivisions);
        })
        .catch(syncQuickBookDivisionsErr => {          
          commit('SET_SYNC_QUICKBOOK_DIVISIONS',{status: "failure", error: syncQuickBookDivisionsErr.message});          
        });
    },
    async getQuickBookHistory( {commit}, payload) {
      await apolloClient
        .mutate({
          mutation: GET_QUICKBOOK_HISTORY_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getQuickBookHistoryData) => {
          commit('GET_QUICKBOOK_HISTORY', getQuickBookHistoryData.data.getQuickBookHistory);          
        })
        .catch(getQuickBookHistoryErr => {
          commit('GET_QUICKBOOK_HISTORY', {status: 'failure', error: getQuickBookHistoryErr.message});          
        });
    },
    async getQuickBookDepartmentList({commit}, payload) {
      await apolloClient
        .mutate({
          mutation: GET_QUICKBOOK_DEPARTMENT_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getQuickBookDepartmentListData) => {
          commit('GET_QUICKBOOK_DEPARTMENT_LIST', getQuickBookDepartmentListData.data.getQuickBookDepartmentList);          
        })
        .catch(getQuickBookDepartmentListErr => {
          commit('GET_QUICKBOOK_DEPARTMENT_LIST', {status: 'failure', error: getQuickBookDepartmentListErr.message});          
        });
    },
    async getQuickBookClassesList({commit}, payload) {
      await apolloClient
        .mutate({
          mutation: GET_QUICKBOOK_CLASS_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getQuickBookClassesListData) => {
          commit('GET_QUICKBOOK_CLASS_LIST', getQuickBookClassesListData.data.getQuickBookClassesList);          
        })
        .catch(getQuickBookClassesListErr => {
          commit('GET_QUICKBOOK_CLASS_LIST', {status: 'failure', error: getQuickBookClassesListErr.message});          
        });
    },
    async getQuickBooksChartOfAccounts({commit}, payload) {
      await apolloClient
        .mutate({
          mutation: GET_QUICKBOOK_CHART_OF_ACCOUNTS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
      .then((getQuickBooksChartOfAccountsData) => {
        commit('GET_QUICKBOOK_CHART_OF_ACCOUNTS', getQuickBooksChartOfAccountsData.data.getQuickBooksChartOfAccounts);          
      })
      .catch(getQuickBooksChartOfAccountsErr => {
        commit('GET_QUICKBOOK_CHART_OF_ACCOUNTS', {status: 'failure', error: getQuickBooksChartOfAccountsErr.message});          
      });
    }    
  },

  getters: {
    quickBookAccessToken: state => state.quickBookAccessToken,
    quickBookRefreshToken: state => state.quickBookRefreshToken,
    qbQuickbookEntry: state => state.qbQuickbookEntry,
    quickBookCategoryList: state => state.quickBookCategoryList,
    quickBookCcAccountList: state => state.quickBookCcAccountList,
    createdAccount: state => state.createdAccount,
    syncedQuickBookCategories: state => state.syncedQuickBookCategories,
    quickBookCredentials: state => state.quickBookCredentials,
    recentlySelectedCreditCardAccount: state => state.recentlySelectedCreditCardAccount,
    quickBookConnectionError: state => state.quickBookConnectionError,
    syncedQuickBookTransactions: state => state.syncedQuickBookTransactions,
    quickBookBankAccountList: state => state.quickBookBankAccountList,
    createdBankAccount: state => state.createdBankAccount,
    syncedQuickBookBankTransactions: state => state.syncedQuickBookBankTransactions,
    syncedQuickBookJournalEntries: state => state.syncedQuickBookJournalEntries,
    mappedCreditCardForQuickBooks: state => state.mappedCreditCardForQuickBooks,
    syncedQuickBookClasses: state => state.syncedQuickBookClasses,
    syncedQuickBookDivisions: state => state.syncedQuickBookDivisions,
    quickBookHistory: state => state.quickBookHistory,
    quickBookDepartmentList: state => state.quickBookDepartmentList,
    quickBookClassesList: state => state.quickBookClassesList,
    quickBookChartOfAccounts: state => state.quickBookChartOfAccounts,
    syncedQuickBookIntercompanyTransactions: state => state.syncedQuickBookIntercompanyTransactions,
  },
};
